import { render, staticRenderFns } from "./ChangeCard.Vue?vue&type=template&id=668ec952"
import script from "./ChangeCard.Vue?vue&type=script&lang=js"
export * from "./ChangeCard.Vue?vue&type=script&lang=js"
import style0 from "./ChangeCard.Vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ChangeCard.Vue
// module id = 42
// module chunks = 0